import { render, staticRenderFns } from "./Kefuyun.vue?vue&type=template&id=cf06e74c&scoped=true"
import script from "./Kefuyun.vue?vue&type=script&lang=js"
export * from "./Kefuyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf06e74c",
  null
  
)

export default component.exports